import React from 'react';
import { NavLink } from 'react-router-dom';
import { useChatInbox } from '../../contexts/ChatInboxContext';
import './FriendsSubNav.css';

function unreadBadgeLabel(count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  if (n <= 0) return '';
  return n > 9 ? '9+' : String(n);
}

/**
 * Secondary bar above PublicBottomNav on Friends routes.
 * Tabs: Friends · Chat
 */
const FriendsSubNav = () => {
  const { unreadTotal } = useChatInbox();
  const badge = unreadBadgeLabel(unreadTotal);

  return (
    <nav className="friends-subnav" aria-label="Friends sections">
      <div className="friends-subnav__inner">
        <NavLink
          to="/friends"
          end
          className={({ isActive }) =>
            `friends-subnav__tab${isActive ? ' is-active' : ''}`
          }
        >
          Friends
        </NavLink>
        <NavLink
          to="/friends/chat"
          className={({ isActive }) =>
            `friends-subnav__tab${isActive ? ' is-active' : ''}`
          }
          aria-label={badge ? `Chat, ${unreadTotal} unread` : 'Chat'}
        >
          Chat
          {badge ? (
            <span className="friends-subnav__badge" aria-hidden="true">
              {badge}
            </span>
          ) : null}
        </NavLink>
      </div>
    </nav>
  );
};

export { unreadBadgeLabel };
export default FriendsSubNav;
